import { analyticsManager } from '@inpart-io/devtools-vue';
import { computed } from 'vue';
import { useRoute } from 'vue-router';

import { ANALYTICS_EVENTS } from '@/constants/analytics.constants';
import { ROUTE_DATA } from '@/constants/routes.constants';

export function useTrackEvent(): {
    onTrackEvent: (eventName: string, params?: unknown) => void;
} {
    const route = useRoute();

    const isOpportunityPage = computed<boolean>(() => {
        const { query = {}, name = '' } = route ?? {};
        return Boolean(name === ROUTE_DATA.LEAD_OVERVIEW_PAGE.name || query?.selectedLead);
    });
    const isCompanyPage = computed<boolean>(() => {
        const { name = '' } = route ?? {};
        return Boolean(name === ROUTE_DATA.COMPANY_OVERVIEW_PAGE.name);
    });
    const isAgreementPage = computed<boolean>(() => {
        const { name = '', query = {} } = route ?? {};
        return Boolean(name === ROUTE_DATA.AGREEMENT_OVERVIEW_PAGE.name || query?.agreementTab);
    });
    const isAlliancePage = computed<boolean>(() => {
        const { name = '' } = route ?? {};
        return Boolean(name === ROUTE_DATA.ALLIANCE_OVERVIEW_PAGE.name);
    });
    const getEventModule = computed<{ [key in string]: string }>(() => {
        if (isOpportunityPage.value) {
            return ANALYTICS_EVENTS.LEAD_DETAILS;
        }
        if (isCompanyPage.value) {
            return ANALYTICS_EVENTS.COMPANY_DETAILS;
        }
        if (isAgreementPage.value) {
            return ANALYTICS_EVENTS.AGREEMENT_DETAILS;
        }
        if (isAlliancePage.value) {
            return ANALYTICS_EVENTS.ALLIANCE_DETAILS;
        }
        return {};
    });

    const onTrackEvent = (eventName: string = '', params = {}): void => {
        if (eventName && getEventModule.value[eventName]) {
            analyticsManager.trackAction(getEventModule.value[eventName], params);
        }
    };

    return {
        onTrackEvent
    };
}
